import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { IPricePerRoomRow, IPricePerRoomRowHeaders } from "./price-per-room-mapping.service";
import { PriceType } from "libraries/component/price/price.component";
import { faCircle, faQuestion, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { FEE_DESCRIPTION } from "libraries/wording/fee-description";
import { MatTable } from "@angular/material/table";

export interface IPricePerRoomData {
    headers: IPricePerRoomRowHeaders;
    total: IPricePerRoomRow[];
    local: IPricePerRoomRow[];
    roomIds: string[];
    colsName: string[];
    canShowCost: boolean;
    canShowRetail: boolean;
}

@Component({
    selector: 'price-per-room',
    template: `
        <div mat-dialog-title>
            <h1>{{wording.title}}</h1>
            <btn type="actionDo"
                 [label]="wording.closeDialog"
                 (click)="closeDialog()">
            </btn>
        </div>
        <div mat-dialog-content class="content" #contentElement>
            <mat-table [dataSource]="data.total" >
                <ng-container matColumnDef="title">
                    <mat-header-cell *matHeaderCellDef class="text title"></mat-header-cell>
                    <mat-cell *matCellDef="let row" class="text title">
                        <div>
                            {{row.title}}
                            <ng-container *ngIf="row.type === 'fee'">
                                <fa-layers (click)="toggleDescription()" #feeDescriptionBtn>
                                    <fa-icon [icon]="iconCircle" class="blue"></fa-icon>
                                    <fa-icon [icon]="iconQuestion" class="white" transform="shrink-5"></fa-icon>
                                </fa-layers>
                            </ng-container>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="total">
                    <mat-header-cell *matHeaderCellDef class="value total"> {{data.headers.total}}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="value total">
                        <div *ngIf="data.canShowCost">
                            <span *ngIf="data.canShowRetail && row.totalRetail" style="font-weight: normal">{{wording.costPrice}}</span>
                            <price [currency]="row.total.currency"
                                    [value]="row.total.amount"
                                    [type]="row.isHeader ? priceType.default: priceType.light"></price>
                        </div>
                        <div *ngIf="data.canShowRetail && row.totalRetail" style="font-weight: normal">
                            <span *ngIf="data.canShowCost">{{wording.retailPrice}}</span>
                            <price *ngIf="row.totalRetail"
                                   [currency]="row.totalRetail.currency"
                                   [value]="row.totalRetail.amount"
                                   [type]="row.isHeader ? priceType.default: priceType.light"></price>
                        </div>

                    </mat-cell>
                </ng-container>

                <ng-container *ngFor="let roomId of data.roomIds" [matColumnDef]="roomId">
                    <mat-header-cell *matHeaderCellDef class="value room"> {{roomId | findRoomName: data.headers.room}}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="value">
                        <div *ngIf="data.canShowCost">
                            <span *ngIf="data.canShowRetail && row.roomRetail" style="font-weight: normal">{{wording.costPrice}}</span>
                            <price [currency]="(roomId | findRoom: row.room).currency"
                                   [value]="(roomId | findRoom: row.room).amount"
                                   [type]="row.isHeader ? priceType.default: priceType.light"></price>
                        </div>
                        <div *ngIf="data.canShowRetail && row.roomRetail" style="font-weight: normal">
                            <span *ngIf="data.canShowCost">{{wording.retailPrice}}</span>
                            <price [currency]="(roomId | findRoom: row.roomRetail).currency"
                                   [value]="(roomId | findRoom: row.roomRetail).amount"
                                   [type]="row.isHeader ? priceType.default: priceType.light"></price>
                        </div>
<!--                        <price [currency]="(roomId | findRoom: row.room).currency"-->
<!--                               [value]="(roomId | findRoom: row.room).amount"-->
<!--                               [type]="row.isHeader ? priceType.default: priceType.light"></price>-->
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="rowEnd">
                    <mat-header-cell *matHeaderCellDef class="end"></mat-header-cell>
                    <mat-cell *matCellDef="let row" class="end"></mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="data.colsName"></mat-header-row>
                <mat-row *matRowDef="let row; columns: data.colsName" [class.is-header]="row.isHeader"></mat-row>

            </mat-table>

            <mat-table [dataSource]="data.local">
                <ng-container matColumnDef="title">
                    <mat-cell *matCellDef="let row" class="text title">
                        <div>{{row.title}}</div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="total">
                    <mat-cell *matCellDef="let row" class="value total">
                        <price [currency]="row.total.currency"
                               [value]="row.total.amount"
                               [type]="row.isHeader ? priceType.default: priceType.light"
                               [allowZeroValue]="true"></price>
                    </mat-cell>
                </ng-container>

                <ng-container *ngFor="let roomId of data.roomIds" [matColumnDef]="roomId">
                    <mat-cell *matCellDef="let row" class="value">
                        <price [currency]="(roomId | findRoom: row.room).currency"
                               [value]="(roomId | findRoom: row.room).amount"
                               [type]="row.isHeader ? priceType.default: priceType.light"
                               [allowZeroValue]="true"></price>
                    </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let row; columns: data.colsName" [class.is-header]="row.isHeader"></mat-row>

                <ng-container matColumnDef="rowEnd">
                    <mat-cell *matCellDef="let row" class="end"></mat-cell>
                </ng-container>

            </mat-table>
            <div class="fee-description" *ngIf="showFeeDescription" [style.width]="descriptionWidth">
                <div>{{feeTitle}}</div>
                <div>{{feeDescription.main}}</div>
            </div>

        </div>`,
    styleUrls: ['./price-per-room.component.scss'],
})

export class PricePerRoomComponent {
    public wording: ILabels = {
        title: Yii.t('wui-shared-js', 'Détail des prix'),
        closeDialog: Yii.t('wui-shared-js', 'Fermer'),
        costPrice: Yii.t('wui-shared-js', "achat: "),
        retailPrice: Yii.t('wui-shared-js', 'vente: '),
    };

    public cols: string[] = ['title', 'total'];

    public priceType: typeof PriceType = PriceType;

    public readonly iconQuestion: IconDefinition = faQuestion;
    public readonly iconCircle: IconDefinition = faCircle;
    public showFeeDescription: boolean;
    public readonly feeDescription: IDescriptionLabels = FEE_DESCRIPTION;
    public descriptionWidth: string;
    public feeTitle: string = Yii.t('wui-shared-js', 'Taxes et frais');

    @ViewChild('contentElement')
    public contentElement: ElementRef;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IPricePerRoomData,
        public dialog: MatDialog,
    ) {
    }

    public toggleDescription(): void {
        this.descriptionWidth = (this.contentElement.nativeElement.offsetWidth - 10) + "px";
        this.showFeeDescription = !this.showFeeDescription;
    }

    public closeDialog(): void {
        this.dialog.closeAll();
    }
}
